






import NavBar from "@/components/NavBar.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "App",
  components: {
    NavBar
  }
})
export default class App extends Vue {}
